<template>
  <div class="page">
    <div class="row">
     <h3 class="title">
        <span >Tìm thấy {{products?products.length:0}} kết quả với từ khóa </span> <b> &nbsp; {{keyword}} </b>
      </h3>
      </div>
      <div class="clearfix"></div>
      <hr>
      <div class="row">
        <div class="col-md-12 col-xs-12">
          <RwvLoader :isLoading="isProductLoading" :fullPage="false"></RwvLoader>
          <RwvProductListItem :products="products"/>
        </div>
      </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import RwvProductListItem from "@/components/ProductListItem";
import { FETCH_PRODUCTS, SEARCH_PRODUCTS } from '@/store/actions.type';
import RwvLoader from "@/components/Loader";

export default {
  name: "RwvProductSearching",
  props: {
    keyword: {
      type: String,
      default: ''
    }
  },
  components: {
    RwvProductListItem,
    RwvLoader
  },
  beforeRouteEnter(to, from, next) {
    Promise.all([store.dispatch(SEARCH_PRODUCTS, to.query.keyword)]).then(
      () => {}
    );

    next();
  },
  computed: {
    ...mapGetters(["products", "isProductLoading"])
  }
};
</script>